import { keyframes, Theme } from '@mui/material';

const loading = keyframes`
  from {
    transform: rotate(0deg)
  }
  to {
    transform: rotate(360deg)
  }
`;

export default (theme: Theme) => ({
  '@keyframes loadingEffect': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
  loading: {
    animation: `${loading} 1.3s infinite linear`,
  },
  small: {
    textTransform: 'capitalize',
    height: theme.spacing(4),
  },
  medium: {
    height: theme.spacing(4.5),
    textTransform: 'capitalize',
  },
  large: {
    height: theme.spacing(5),
    textTransform: 'capitalize',
  },
  disabled: {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.getContrastText(
      theme.palette.action.disabledBackground,
    ),
    '&:hover': {
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.getContrastText(theme.palette.grey[300]),
    },
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
    },
  },
  warning: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.black,
    '&:hover': {
      backgroundColor: theme.palette.warning.light,
    },
  },
  error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.error.light,
    },
  },
  success: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.success.light,
    },
  },
  grey: {
    backgroundColor: theme.palette.grey[500],
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.grey[600],
    },
  },

  greyCount: {
    color: theme.palette.grey[400],
    backgroundColor: theme.palette.primary.contrastText,
  },
  primaryCount: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.contrastText,
  },
  secondaryCount: {
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.secondary.contrastText,
  },
  warningCount: {
    color: theme.palette.warning.main,
    backgroundColor: theme.palette.warning.contrastText,
  },
  errorCount: {
    color: theme.palette.error.main,
    backgroundColor: theme.palette.error.contrastText,
  },
  successCount: {
    color: theme.palette.success.main,
    backgroundColor: theme.palette.success.contrastText,
  },
});
